let plugins = ['tk', 'index', 'vuexStorage']
if (process.env.VUE_APP_ENV === 'app') {
  plugins = [
    ...plugins,
    'user',
    'routerAuth',
    'initMid'
  ]
}
const config = {
  vuexStorageKeys: [
    'sessionToken',
    'user',
    'isRead',
    'shoppingSum',
    'searchWords'
  ],
  plugins: plugins,
  apiUrl: 'https://cloud.dianpei.mokekeji.com',
  // apiUrl: 'http://localhost:3333',
  // https://cloud.dianpei.mokekeji.com
  cloudUrl: 'https://cloud.dianpei.mokekeji.com',
  appID: 'xQCFYoSjBzaIqtzYpZQvxcD7wWYx7zdb',
  restKey: 'tdmgHayeqUyekcUmlxuOMJrtHWQXZ95G',
  masterKey: 'oqCKSlLGjW6IdkWXZqxZ1BYJBaKrqbXs',
  statusBarColor: '#FFFFFF',
  mobileView: true,
  modelJSON: require('./assets/json/model'),
  iconJSON: require('./assets/json/icon'),
  payId: '32ec9ec5-f9a7-4cfd-8309-85baf1085af2',
  paysecret: 'cbd03187-2141-4a31-8459-195517ff61c2'
  // moke
  // payId: '15920a19-54ef-4761-956a-2aaeed9386bf',
  // paysecret: '4b378d27-3500-44b4-9c9b-237c9fbe4a59'
}
// config.cloudUrl = 'http://192.168.50.119:3333'
export default config
